export interface BaseRouteData {
  identifier?: string;
}
